import AppRouter from '@/routes/AppRouter';

/**
 * Componente raiz - apenas monta o router. Provider do TanStack Query está em main.tsx.
 */
export default function App() {
  return <AppRouter />;
}
